/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class EmptyStringInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const cloned = req.clone({
      body: this.transformEmptyStrings(req.body),
    });
    return next.handle(cloned);
  }

  private transformEmptyStrings(obj: any): any {
    if (typeof obj === 'string') {
      return obj.trim() === '' ? null : obj;
    } else if (Array.isArray(obj)) {
      return obj.map((v) => this.transformEmptyStrings(v));
    } else if (obj instanceof Date) {
      return obj;
    } else if (obj && typeof obj === 'object') {
      const copy: any = {};
      for (const key of Object.keys(obj)) {
        copy[key] = this.transformEmptyStrings(obj[key]);
      }
      return copy;
    }
    return obj;
  }
}
